import { AggregationGroup } from 'src/app/services/jsonrpc/stats-server.service';
import { AnalyticsMetric } from 'src/app/services/stats.service';

import { Dashboard } from './dashboard.component';

const content: Dashboard = {
  widgets: [
    {
      size: 3,
      component: 'users'
    },
    {
      size: 3,
      component: 'usersPeak'
    },
    {
      size: 3,
      component: 'usersPeakDate'
    },
    {
      size: 3,
      component: 'totalActiveTime'
    },

    {
      size: 12,
      component: 'multiTable',
      settings: {
        title: 'Overview',
        grouping: null,
        rows: [
          { title: 'Registered Users', metric: AnalyticsMetric.users },
          { title: 'Games Played', metric: AnalyticsMetric.games_played },
          { title: 'Active Time', metric: AnalyticsMetric.time }
        ],
        totalColumn: true
      }
    },

    {
      size: 12,
      component: 'transitionGraph'
    },

    // AI tutor usage (C4); renders nothing unless the tutor is enabled and the user may read stats.
    {
      size: 12,
      component: 'tutorUsage'
    },

    {
      component: 'barChart',
      settings: {
        title: 'Users by licence',
        metric: AnalyticsMetric.users,
        grouping: AggregationGroup.licences,
        customize: false
      }
    },

    {
      component: 'barChart',
      settings: {
        title: 'Online time by licence',
        metric: AnalyticsMetric.time,
        grouping: AggregationGroup.licences,
        customize: false
      }
    },

    {
      size: 12,
      component: 'barChart',
      settings: {
        title: 'Modules used by licence',
        subtitle: 'Online time in modules by licence key',
        metric: AnalyticsMetric.time,
        grouping: AggregationGroup.path_segment_1,
        datasets: AggregationGroup.licences,
        exclude: {
          [AggregationGroup.path_segment_1]: ['article', 'glossary', 'invite', 'Sidemenu']
        },
        customize: false,
        totalRow: false,
        totalColumn: false,
        relative: false
      }
    },

    {
      size: 12,
      component: 'barChartFiltered',
      settings: {
        title: 'Submodules used by licence',
        subtitle: 'Online time in submodules by licence key',
        metric: AnalyticsMetric.time,
        selector: AggregationGroup.path_segment_1,
        grouping: AggregationGroup.path_segment_2,
        datasets: AggregationGroup.licences,
        exclude: {
          [AggregationGroup.path_segment_1]: ['article', 'glossary', 'invite', 'Sidemenu'],
          [AggregationGroup.licences]: '[]'
        },
        customize: false,
        totalRow: false,
        totalColumn: false,
        relative: false
      }
    },

    {
      component: 'lineGraph',
      settings: {
        title: 'Active Hours',
        subtitle: 'Total time in hours spent in the app over the day',
        metric: AnalyticsMetric.time,
        datasets: AggregationGroup.feature,
        grouping: AggregationGroup.hour,
        labelNames: '{value}:00'
      }
    },

    {
      component: 'lineGraph',
      settings: {
        title: 'Daily Playtime',
        subtitle: 'Total recent time in hours spent in the app',
        metric: AnalyticsMetric.time,
        datasets: AggregationGroup.feature,
        grouping: AggregationGroup.date,
        timespan: { days: 21 }
      }
    },

    {
      component: 'lineGraph',
      settings: {
        title: 'Weekly Playtime',
        subtitle: 'Total recent time in hours spent in the app',
        metric: AnalyticsMetric.time,
        datasets: AggregationGroup.feature,
        grouping: [AggregationGroup.year, AggregationGroup.week],
        timespan: { weeks: 12 }
      }
    },

    {
      component: 'lineGraph',
      settings: {
        title: 'Monthly Playtime',
        subtitle: 'Total recent time in hours spent in the app',
        metric: AnalyticsMetric.time,
        datasets: AggregationGroup.feature,
        grouping: [AggregationGroup.year, AggregationGroup.month],
        timespan: { months: 12 }
      }
    },

    {
      component: 'barChart',
      settings: {
        title: 'Video Plays',
        filter: {
          [AggregationGroup.feature]: 'video'
        },
        metric: AnalyticsMetric.media_plays,
        grouping: AggregationGroup.path,
        customize: false
      }
    },

    {
      component: 'barChart',
      settings: {
        title: 'Quiz Games by Licence',
        metric: AnalyticsMetric.games_played,
        grouping: AggregationGroup.licences,
        customize: false
      }
    }
  ]
};

export default content;
